import { render, staticRenderFns } from "./XmlUploadRequestsIndex.vue?vue&type=template&id=61a9a1db&scoped=true"
import script from "./XmlUploadRequestsIndex.vue?vue&type=script&lang=js"
export * from "./XmlUploadRequestsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9a1db",
  null
  
)

export default component.exports